import React from "react";
import KidImg from "../../assets/images/InternationalAcademy/kids1.jpg";
import KidImg1 from "../../assets/images/InternationalAcademy/kids2.jpg";
import KidImg2 from "../../assets/images/InternationalAcademy/kids3.jpg";
import KidImg3 from "../../assets/images/InternationalAcademy/kids4.jpg";
const Instagram = () => {
  return (
    <div id="instagram">
      <div className="fontstyle2 py-20 lg:px-14 px-5  ">
        <h2 className="text-2xl font-semibold text-center ">
          Instagram @sismyanmar
        </h2>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-10">
          <img src={KidImg} alt="" className="h-full object-cover" />
          <img src={KidImg1} alt="" />
          <img src={KidImg2} alt="" />
          <img src={KidImg3} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Instagram;
